import styled from '@emotion/styled';

import { fontSize, fontWeight } from '@datacamp/waffles-tokens';

// Partial port of Tag from Waffles
// If options are missing, they'll need to be ported as well
// https://github.com/datacamp-engineering/design-system/tree/master/packages/stylesheets/card

/* eslint-disable import/prefer-default-export */
export const Container = styled.span`
  align-items: center;
  background-color: ${props =>
    props.bg ? props.bg : props.theme.colors.primaryLightest};
  border: ${props =>
    props.bg ? '0' : `1px solid ${props.theme.colors.greyLighter}`};
  color: ${props => props.textColor && props.textColor};
  border-radius: ${props => (props.radius ? `${props.radius}px` : '12px')};
  display: inline-flex;
  font-size: ${fontSize.micro};
  font-weight: ${fontWeight.bold};
  letter-spacing: 0.6px; /* 1@16px->0.8@14px->0.6@12px */
  line-height: 1;
  padding: ${props => (props.bg ? '6px 12px' : '5px 11px')};
  position: relative;
  text-transform: uppercase;
  white-space: nowrap;
`;
